





















































































































































import { Vue, Prop, Component } from 'vue-property-decorator';
import { ProductTileViewObject, BidViewObject } from '@/types/apiServerContract';
import { PriceSimpleDataExtended } from '@/project/product/services/simplePriceFetch.service';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';

import loginFormOverlayService from '@/project/modals/overlays/LoginFormOverlay.service';
import serverContextService from '@/core/serverContext.service';
import dictionaryService from '@/core/translation/dictionary.service';
import gtmService from '@/project/tracking/gtm/GTM.service';
import urlHelperService from '@/core/urlHelper.service';
import { UrlQueryKey } from '@/core/urlQueryKey';
const ProductTileDiscount = () => import(/* webpackChunkName: 'auth-feature' */'@/project/product/product-tile/ProductTileDiscounts.vue');
const AddToBasket = () => import(/* webpackChunkName: 'auth-feature' */'@/project/basket/AddToBasket.vue');

@Component({
    components: { AddToBasket, ProductTileDiscount, SpinnerOverlay }
})
export default class ProductTileCart extends Vue {
    @Prop({ required: true }) product!: ProductTileViewObject;
    @Prop({ required: false, default: null }) bid!: BidViewObject | null;
    @Prop({ required: true }) price!: { loaded: boolean, data: PriceSimpleDataExtended };
    @Prop({ required: false, default: false }) isLoggedIn!: boolean;
    @Prop({ required: false, type: String, default: 'vertical' }) mode!: 'vertical' | 'horizontal' | 'horizontal-tiny' | 'unknown';
    @Prop({ required: false, default: false, type: Boolean }) isBidOnPdp!: boolean;
    @Prop({ required: false, default: true, type: Boolean }) showAddToBasket!: boolean;
    @Prop({ required: false, type: Function, default: () => {} }) productClick!: () => void;

    get isInVerticalMode() {
        return this.mode === 'vertical';
    }

    get isInHorizontalMode() {
        return this.mode === 'horizontal' || this.mode === 'horizontal-tiny';
    }

    get basketStyle() {
        return this.isInVerticalMode ? 'tile-condensed' : 'tile';
    }

    get loaded(): boolean {
        return this.price?.loaded;
    }

    get isServiceAvailable(): boolean {
        return this.price?.data?.isServiceAvailable ?? false;
    }

    get isPriceAvailable(): boolean {
        return (this.price?.data !== null && this.price.data.amount.cultureFormatted !== null) || this.hasAvailableBid;
    }

    get hasAvailableBid() {
        return !!this.bid?.price;
    }

    get hasPrice() {
        return !!this.price?.data?.amount.cultureFormatted;
    }

    get previousPrice() {
        return this.price.data?.previousPrice.cultureFormatted && this.price.data?.previousPrice;
    }

    get suggestedRetailPrice() {
        return this.price.data?.suggestedRetailPrice.cultureFormatted && this.price.data?.suggestedRetailPrice;
    }

    get hasQuantityDiscounts() {
        return this.price?.data?.hasQuantityDiscounts ?? false;
    }

    get maxQuantity() {
        return this.bid?.remQty ?? 99999;
    }

    showLoginOverlay() {
        gtmService.trackLogInToViewPricesClick();
        loginFormOverlayService.show('login');
    }

    get bidId(): number | null {
        return this.bid?.id ?? null;
    }

    // Loaded via IFrame
    get isExternalProductGuide() {
        return serverContextService.isExternalProductGuide;
    }

    get productLink() {
        return serverContextService.productUrl(this.product);
    }

    get productLinkText() {
        return serverContextService.externalProductLinkText
            ? serverContextService.externalProductLinkText
            : dictionaryService.get('Product.ExternalLink.DefaultText');
    }

    get externalProductLinkTarget() {
        return serverContextService.externalProductLinkTarget;
    }

    get externalTheme() {
        const externalTheme = serverContextService.externalProductGuideSettings?.theme;
        const theme: string = externalTheme || (urlHelperService.getQueryParam(UrlQueryKey.theme) || 'green').replace('invert-', '');
        return `cta--${theme}`;
    }

    addToBasketChange(deltaQuantity, quantity) {
        this.$emit('add-to-basket-change', deltaQuantity, quantity);
    }
}
